import styled from 'styled-components';

export const SizeName = styled.span`
  flex-basis: 33%;
  flex-grow: 1;
  width: 100%;
  display: flex;
  cursor: pointer;
  position: relative;
  min-height: ${props => props.theme.basketItem.option.lineHeight};
  font-size: ${props => props.theme.basketItem.size.fontSize};
  padding-right: ${props => props.theme.padding};
`;
export const SizeContent = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: ${props => props.theme.basketItem.option.margin};
  width: 100%;
  padding: ${p => p.theme.basketItem.option.padding};
  color: ${props => props.isSelected ? props.theme.primaryColor : props.theme.basketItem.size.color};
  border-radius: ${props => props.theme.basketItem.option.borderRadius};
  background-color: ${props => props.isSelected ? props.theme.basketItem.selected.backgroundColor : 'none'};
  box-shadow: ${props => props.isSelected ? props.theme.basketItem.selected.boxShadow : 'none'};
  &:hover {
    background-color: ${props => props.isSelected ? '' : props.theme.basketItem.selected.color};
    background-image: ${props => props.isSelected ? '' : props.theme.basketItem.option.backgroundImage};
    box-shadow: ${props => props.isSelected ? '' : props.theme.basketItem.option.boxShadow};
  }
`;



// WEBPACK FOOTER //
// ./components/Meal/Size.style.js